import React from 'react';
import Legal from './legal';
import Toolbar from './toolbar';

import * as styles from './footer.styles';

const Footer: React.FC = () => (
  <footer css={styles.container}>
    <div css={styles.inner}>
      <Toolbar />
      <Legal />
    </div>
  </footer>
);

export default Footer;
